// extracted by mini-css-extract-plugin
export default {"orderNumberLink":"ecooZPTR","chargeValue":"LPugcklc"};